import type { MaybeN } from "@agrigate/ts-utils/lib/types";
import type { ButtonProps } from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import type { CSSProperties } from "react";

export default function SwitchButtonCombo(p: {
    options: {
        value: string;
        label: string;
    }[];
    selected: MaybeN<string>;
    onChange: (id: string) => void;
    variant?: ButtonProps["variant"];
    styles?: {
        group?: CSSProperties;
        buttons?: {
            selected?: CSSProperties;
            deselected?: CSSProperties;
        };
    };
    size?: ButtonProps["size"];
    isAttached?: boolean;
}) {
    return (
        <ButtonGroup
            size={p.size ?? "sm"}
            attached={p.isAttached ?? true}
            variant={p.variant ?? "outline"}
            style={p.styles?.group}
        >
            {p.options.map(opt => {
                const isSelected = p.selected === opt.value;
                return (
                    <Button
                        key={opt.value}
                        style={
                            isSelected
                                ? {
                                      zIndex: 1,
                                      color: "var(--chakra-colors-blue-500)",
                                      background:
                                          "var(--chakra-colors-blue-50)",
                                      borderColor:
                                          "var(--chakra-colors-blue-500)",
                                      ...p.styles?.buttons?.selected,
                                  }
                                : {
                                      // [x]: this should come from default from theme
                                      borderColor: "#E9ECF0",
                                      ...p.styles?.buttons?.deselected,
                                  }
                        }
                        onClick={() => p.onChange(opt.value)}
                    >
                        {opt.label}
                    </Button>
                );
            })}
        </ButtonGroup>
    );
}
